import React from 'react';
import PropTypes from 'prop-types';
import Roundel from '../../../components/PromoIconography/PromoRoundel/Roundel';
import styles from '../../../components/PromoIconography/PromoRoundel/PromoRoundel.module.scss';
const PromoRoundel = ({ display = false, image, supercharged = false }) => {
    if (!display || !image || supercharged)
        return null;
    return (React.createElement("div", { className: styles.promoRoundel, "data-testid": "promo-roundel" },
        React.createElement(Roundel, { image: image })));
};
PromoRoundel.displayName = 'PromoRoundel';
PromoRoundel.propTypes = {
    display: PropTypes.bool,
    image: PropTypes.object.isRequired,
    supercharged: PropTypes.bool,
};
export default PromoRoundel;
//# sourceMappingURL=index.js.map